import axios from '../axios/redditlikeApi'

const getCommentsByPostId = (postId) => axios.get(`/posts/${postId}/comments`)

const createComment = (postId, form) => axios.post(`/posts/${postId}/comments`, form)

const updateCommentsById = (postId, commentId, form) => axios.patch(`/posts/${postId}/comments/${commentId}`, form)

const deleteCommentsById = (postId, commentId) => axios.delete(`/posts/${postId}/comments/${commentId}`)

export default {
  getCommentsByPostId,
  createComment,
  updateCommentsById,
  deleteCommentsById
}
